import { t } from 'i18next';

import { ErrorResponseErrorItemCodeAccount } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeAccount, string> => ({
  'account:not_found': t('account.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Kontot existerar inte.',
  }),
});
